import { render, staticRenderFns } from "./AltUniswapChartTwo.vue?vue&type=template&id=72c96daa&scoped=true&"
import script from "./AltUniswapChartTwo.vue?vue&type=script&lang=js&"
export * from "./AltUniswapChartTwo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c96daa",
  null
  
)

export default component.exports